import { HttpErrorResponse } from '@angular/common/http';
import { isMessageBasket, MessageBasket } from './message-basket';

const MSG_SERVICE_TEMPORARILY_UNAVAILABLE = 'msg_service_temporarily_unavailable';

function userFacingCause(source?: unknown): string {
  if (source == null) {
    return 'No response was received.';
  }
  if (source instanceof HttpErrorResponse) {
    if (source.status === 0) {
      return 'The server did not return a response (network, CORS, or service unavailable).';
    }
    return source.message || `HTTP ${source.status}`;
  }
  if (typeof ProgressEvent !== 'undefined' && source instanceof ProgressEvent) {
    return `Browser network error (${source.type}).`;
  }
  if (source !== null && typeof source === 'object' && 'isTrusted' in source) {
    const e = source as Record<string, unknown>;
    return `Browser network error${e.type ? ` (${e.type})` : ''}.`;
  }
  if (source instanceof Error) {
    const m = source.message || '';
    return m.length > 160 ? `${m.slice(0, 160)}…` : m;
  }
  return 'Connection failed before a complete response.';
}

function isTransientHttpFailure(error: unknown): boolean {
  if (error instanceof HttpErrorResponse) {
    return error.status === 0;
  }
  if (typeof ProgressEvent !== 'undefined' && error instanceof ProgressEvent) {
    return error.type === 'error';
  }
  return false;
}

export function messageBasketForTransientFailure(source?: unknown): MessageBasket {
  return MessageBasket.error(MSG_SERVICE_TEMPORARILY_UNAVAILABLE, {
    cause: userFacingCause(source),
  });
}

export function normalizeClientFailureForNotification(error: unknown): MessageBasket | undefined {
  if (isMessageBasket(error)) {
    return undefined;
  }
  if (isTransientHttpFailure(error)) {
    return messageBasketForTransientFailure(error);
  }
  if (error instanceof Error) {
    const m = error.message || '';
    if (/network error|failed to fetch|load failed|connection refused/i.test(m)) {
      return messageBasketForTransientFailure(error);
    }
  }
  return undefined;
}
